/**
 * Generates the anchor ID for the contributions section of a participative module.
 * This ID is used for scroll anchoring when navigating from word clouds.
 */
export const getContributionsAnchorId = participativeModuleSlug => {
  return participativeModuleSlug
    ? `participative-module-contributions-${participativeModuleSlug}`
    : null;
};
